import { useCallback } from "react";
import { isDev } from "../../../../base/index.js";
import { useCalendarConfiguration } from "../CalendarRoot.js";
function useHandleDayClick(onClick) {
  const { readonly } = useCalendarConfiguration();
  return useCallback(
    (e) => {
      if (!onClick || readonly) return;
      if (e.target && !e.target.matches('button[data-calendar="day"]')) {
        return;
      }
      const dataset = e.target.dataset;
      const { day, resetSelection = "0" } = dataset;
      if (!day) {
        if (isDev()) {
          throw new Error("Invalid day dataset");
        }
        return;
      }
      const type = e.type === "dblclick" ? "dblclick" : "click";
      const targetDay = resetSelection === "1" ? void 0 : day;
      onClick(targetDay, type);
    },
    [onClick, readonly]
  );
}
export {
  useHandleDayClick
};
//# sourceMappingURL=useHandleDayClick.js.map
